// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"yH-z","heading":"zH-z","cardOverride":"AH-z"};